import React, { useEffect, Children } from 'react';
import { motion } from 'framer-motion';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export const PrivacyPolicy = () => {
  // Scroll to top on component mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="font-[Inter,ui-sans-serif,system-ui] text-[#0B1220] overflow-x-hidden relative bg-gradient-to-b from-[#f8faff] to-[#f0f5ff]" data-id="element-847">
      {/* Cinematic frame markers - subtle guides at the edges of the viewport */}
      <div className="fixed inset-x-0 top-0 h-[2px] bg-[#2E6BFF]/5 z-50" data-id="element-848"></div>
      <div className="fixed inset-x-0 bottom-0 h-[2px] bg-[#2E6BFF]/5 z-50" data-id="element-849"></div>
      <div className="fixed inset-y-0 left-0 w-[2px] bg-[#2E6BFF]/5 z-50" data-id="element-850"></div>
      <div className="fixed inset-y-0 right-0 w-[2px] bg-[#2E6BFF]/5 z-50" data-id="element-851"></div>
      {/* Dynamic background elements */}
      <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none" data-id="element-852">
        <div className="absolute top-0 right-0 w-[80vw] h-[80vh] rounded-full bg-gradient-to-b from-[#2E6BFF]/5 to-transparent opacity-40 blur-[120px]" data-id="element-853"></div>
        <div className="absolute bottom-0 left-0 w-[70vw] h-[70vh] rounded-full bg-gradient-to-t from-[#36D1DC]/5 to-transparent opacity-40 blur-[100px]" data-id="element-854"></div>
        <motion.div className="absolute top-1/4 left-1/4 w-[50vw] h-[50vh] rounded-full bg-gradient-to-r from-[#0BB489]/5 to-transparent opacity-30 blur-[80px]" animate={{
        x: [0, 20, 0],
        y: [0, -20, 0]
      }} transition={{
        duration: 20,
        repeat: Infinity,
        repeatType: 'reverse',
        ease: 'easeInOut'
      }} data-id="element-855"></motion.div>
      </div>
      <Navbar data-id="element-856" />
      <main className="relative z-10 pt-24 pb-16" data-id="element-857">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-858">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg p-6 sm:p-8 border border-white/50" data-id="element-859">
            <h1 className="text-3xl font-bold mb-6 text-[#0B1220]" data-id="element-860">
              Privacy Policy
            </h1>
            <p className="text-gray-600 mb-6" data-id="element-861">Last updated: October 1, 2024</p>
            <div className="space-y-6 text-[#0B1220]" data-id="element-862">
              <p data-id="element-863">
                Pigeon Documents Incorporated ("Pigeon Documents," "we," "us,"
                or "our") is committed to protecting the privacy of our
                customers, clients, and website visitors. This Privacy Policy
                applies to www.pigeondocuments.com and any other websites,
                applications, or services that we own or operate and that link
                to this Privacy Policy (collectively, the "Services"). This
                Privacy Policy explains how we collect, use, and disclose
                information through the Services.
              </p>
              <section data-id="element-864">
                <h2 className="text-xl font-semibold mb-3 text-[#2E6BFF]" data-id="element-865">
                  Information Collection
                </h2>
                <p className="mb-3" data-id="element-866">
                  We may collect information from you in a variety of ways,
                  including when you visit our website, create an account, use
                  our Services, or otherwise interact with us. The types of
                  information we may collect include:
                </p>
                <ul className="list-disc pl-6 space-y-1" data-id="element-867">
                  <li data-id="element-868">
                    Personal information, such as your name, email address, and
                    other contact information
                  </li>
                  <li data-id="element-869">
                    Account information, such as your username and password
                  </li>
                  <li data-id="element-870">
                    Information about your use of our Services, such as the
                    documents you upload and the actions you take within the
                    Services
                  </li>
                  <li data-id="element-871">
                    Device information, such as your IP address, browser type,
                    and operating system
                  </li>
                  <li data-id="element-872">
                    Location information, if you enable location services on
                    your device
                  </li>
                </ul>
              </section>
              <section data-id="element-873">
                <h2 className="text-xl font-semibold mb-3 text-[#2E6BFF]" data-id="element-874">
                  Information Use
                </h2>
                <p className="mb-3" data-id="element-875">
                  We may use the information we collect for a variety of
                  purposes, including:
                </p>
                <ul className="list-disc pl-6 space-y-1" data-id="element-876">
                  <li data-id="element-877">To provide, maintain, and improve our Services</li>
                  <li data-id="element-878">
                    To personalize your experience and tailor the content and
                    information we present to you
                  </li>
                  <li data-id="element-879">
                    To contact you with important information about your account
                    or our Services
                  </li>
                  <li data-id="element-880">
                    To conduct research and analysis to improve our Services
                  </li>
                  <li data-id="element-881">
                    To enforce our terms of service and prevent fraudulent or
                    illegal activity
                  </li>
                </ul>
              </section>
              <section data-id="element-882">
                <h2 className="text-xl font-semibold mb-3 text-[#2E6BFF]" data-id="element-883">
                  Information Disclosure
                </h2>
                <p className="mb-3" data-id="element-884">
                  We may disclose information we collect to:
                </p>
                <ul className="list-disc pl-6 space-y-1" data-id="element-885">
                  <li data-id="element-886">
                    Third-party service providers who help us provide and
                    improve our Services
                  </li>
                  <li data-id="element-887">
                    Law enforcement or other government agencies, as required by
                    law or in response to a valid legal request
                  </li>
                  <li data-id="element-888">
                    Other third parties when we believe disclosure is necessary
                    to protect the rights, property, or safety of Pigeon
                    Documents or others
                  </li>
                  <li data-id="element-889">
                    Customer Notification: If Pigeon Documents receives a
                    legally binding request for the disclosure of your personal
                    information (e.g., a court order or government request), we
                    will notify you unless we are legally prohibited from doing
                    so (for example, due to a gag order or similar legal
                    restriction). The notification will include details of the
                    request and the information disclosed, unless restricted by
                    law.
                  </li>
                </ul>
                <p className="mt-4" data-id="element-890">
                  No mobile information will be shared with third parties or
                  affiliates for marketing or promotional purposes. All the
                  above categories exclude text messaging originator opt-in data
                  and consent; this information will not be shared with any
                  third parties.
                </p>
              </section>
              <section data-id="element-891">
                <h2 className="text-xl font-semibold mb-3 text-[#2E6BFF]" data-id="element-892">
                  Our Role in Data Processing
                </h2>
                <p className="mb-3" data-id="element-893">
                  Pigeon Documents operates as a data processor for our business
                  clients, handling and transferring documents on their behalf
                  through our web-based document management system. We are
                  committed to complying with applicable regulations, including
                  the General Data Protection Regulation (GDPR), the California
                  Consumer Privacy Act (CCPA), and the Health Insurance
                  Portability and Accountability Act (HIPAA), among others.
                </p>
                <ul className="list-disc pl-6 space-y-1" data-id="element-894">
                  <li data-id="element-895">
                    We only process personal data based on our clients'
                    instructions.
                  </li>
                  <li data-id="element-896">
                    We implement robust security measures to protect the
                    confidentiality and integrity of the data.
                  </li>
                  <li data-id="element-897">
                    We work with third-party service providers who adhere to the
                    same security and privacy standards.
                  </li>
                  <li data-id="element-898">
                    We support our clients in fulfilling their legal
                    obligations, such as responding to data subject access
                    requests.
                  </li>
                </ul>
              </section>
              <section data-id="element-899">
                <h2 className="text-xl font-semibold mb-3 text-[#2E6BFF]" data-id="element-900">
                  Data Subject Rights and Communication
                </h2>
                <p className="mb-3" data-id="element-901">
                  As a user of Pigeon Documents, you have the following rights
                  regarding your personal data under applicable data protection
                  laws, including the General Data Protection Regulation (GDPR):
                </p>
                <ul className="list-disc pl-6 space-y-2" data-id="element-902">
                  <li data-id="element-903">
                    <strong data-id="element-904">Access to Information:</strong> You have the right
                    to request access to the personal information we hold about
                    you. You can request a copy of your personal data by
                    contacting us at support@pigeondocuments.com.
                  </li>
                  <li data-id="element-905">
                    <strong data-id="element-906">Rectification:</strong> You have the right to
                    correct inaccurate personal information about you.
                  </li>
                  <li data-id="element-907">
                    <strong data-id="element-908">Erasure:</strong> You have the right to request the
                    deletion of your personal data in certain circumstances,
                    such as when the data is no longer necessary for the purpose
                    for which it was collected.
                  </li>
                  <li data-id="element-909">
                    <strong data-id="element-910">Objection to Processing:</strong> You have the right
                    to object to the processing of your personal data,
                    particularly where processing is based on our legitimate
                    interests or for direct marketing purposes.
                  </li>
                  <li data-id="element-911">
                    <strong data-id="element-912">Data Portability:</strong> You have the right to
                    request that we provide your personal data in a commonly
                    used, machine-readable format for transfer to another data
                    controller.
                  </li>
                  <li data-id="element-913">
                    <strong data-id="element-914">Automated Decision-Making:</strong> You have the
                    right not to be subject to decisions made solely based on
                    automated processing, including profiling, which produce
                    legal effects concerning you or similarly significantly
                    affect you.
                  </li>
                  <li data-id="element-915">
                    <strong data-id="element-916">Withdrawal of Consent:</strong> You have the right
                    to withdraw your consent for the processing of your personal
                    data at any time. To do so, please contact us at
                    support@pigeondocuments.com. Upon receiving your request, we
                    will stop processing your data and ensure that it is deleted
                    or anonymized within 30 days, unless we are required by law
                    to retain it.
                  </li>
                </ul>
                <p className="mt-4" data-id="element-917">
                  To submit a request related to any of the above rights (e.g.,
                  access, correction, erasure, restriction of processing, data
                  portability, objection to processing, or withdrawal of
                  consent), please contact our Data Protection Officer (contact
                  information below). Upon receiving your request, we will
                  acknowledge receipt within 72 hours, and we aim to process all
                  valid requests within 30 days.
                </p>
                <p className="mt-4" data-id="element-918">
                  Please note, to protect your personal data, we may require
                  additional information to verify your identity before
                  processing your request.
                </p>
                <p className="mt-4" data-id="element-919">
                  If you are unsatisfied with our handling of your request, you
                  have the right to lodge a complaint with a supervisory
                  authority.
                </p>
                <p className="mt-4" data-id="element-920">
                  To exercise any of these rights, or if you have any questions
                  or concerns about how we process your personal data, please
                  contact us at support@pigeondocuments.com.
                </p>
                <p className="mt-4" data-id="element-921">
                  Alternatively, if you are located in the European Union, you
                  may contact our appointed GDPR representative, Prighter, as
                  described below.
                </p>
                <p className="mt-4" data-id="element-922">
                  We will respond to your request within a reasonable timeframe,
                  and always in accordance with applicable data protection laws.
                </p>
              </section>
              <section data-id="element-923">
                <h2 className="text-xl font-semibold mb-3 text-[#2E6BFF]" data-id="element-924">
                  Objection to Data Processing
                </h2>
                <p data-id="element-925">
                  You may object to the processing of your personal data at any
                  time for direct marketing purposes or for other processing
                  activities based on our legitimate interest. If you object, we
                  will cease processing your personal data unless we can
                  demonstrate compelling legitimate grounds for the processing
                  that override your interests, rights, and freedoms, or if
                  processing is necessary for the establishment, exercise, or
                  defense of legal claims.
                </p>
              </section>
              <section data-id="element-926">
                <h2 className="text-xl font-semibold mb-3 text-[#2E6BFF]" data-id="element-927">
                  Security
                </h2>
                <p data-id="element-928">
                  We take the security of your information very seriously and
                  have implemented robust measures to protect the information we
                  collect from loss, misuse, and unauthorized access,
                  disclosure, alteration, and destruction. We utilize and build
                  on the same industry-leading end-to-end encryption and
                  security standards that banks and government agencies use to
                  keep sensitive documents safe. However, no method of
                  electronic storage or internet transmission is 100% secure, so
                  we cannot guarantee the absolute security of your information.
                </p>
              </section>
              <section data-id="element-929">
                <h2 className="text-xl font-semibold mb-3 text-[#2E6BFF]" data-id="element-930">
                  Cookies and Other Tracking Technologies
                </h2>
                <p data-id="element-931">
                  We may use cookies and other tracking technologies to collect
                  information about your use of our Services. Cookies are small
                  data files that are stored on your device when you visit a
                  website. We may use both session cookies, which expire when
                  you close your browser, and persistent cookies, which stay on
                  your device until they expire or you delete them. You can
                  control the use of cookies through your browser settings.
                </p>
              </section>
              <section data-id="element-932">
                <h2 className="text-xl font-semibold mb-3 text-[#2E6BFF]" data-id="element-933">
                  Children's Privacy
                </h2>
                <p data-id="element-934">
                  Our Services are not intended for children under the age of
                  18. We do not knowingly collect personal information from
                  children under 18. If we learn that we have collected personal
                  information from a child under 18, we will take steps to
                  delete that information as soon as possible.
                </p>
              </section>
              <section data-id="element-935">
                <h2 className="text-xl font-semibold mb-3 text-[#2E6BFF]" data-id="element-936">
                  Changes to this Privacy Policy
                </h2>
                <p data-id="element-937">
                  We may make changes to this Privacy Policy from time to time.
                  We will post any changes on this page and, if the changes are
                  significant, we will provide a more prominent notice
                  (including, for certain services, email notification of
                  Privacy Policy changes). By continuing to use our Services
                  after any changes become effective, you agree to be bound by
                  the revised Privacy Policy.
                </p>
              </section>
              <section data-id="element-938">
                <h2 className="text-xl font-semibold mb-3 text-[#2E6BFF]" data-id="element-939">
                  Contact Us
                </h2>
                <p data-id="element-940">
                  If you have any questions or concerns about this Privacy
                  Policy or our data practices, please contact us at
                  support@pigeondocuments.com.
                </p>
              </section>
              <section data-id="element-941">
                <h2 className="text-xl font-semibold mb-3 text-[#2E6BFF]" data-id="element-942">
                  Data Protection Officer
                </h2>
                <p data-id="element-943">
                  We have appointed a Data Protection Officer (DPO) to oversee
                  compliance with our data protection policies. If you have any
                  questions or concerns regarding our data protection practices,
                  you may contact our DPO.
                </p>
                <p className="mt-2" data-id="element-944">
                  <strong data-id="element-945">Data Protection Officer:</strong> Adam Bulow
                  <br data-id="element-946" />
                  <strong data-id="element-947">Email:</strong> adam@pigeondocuments.com
                </p>
              </section>
              <section data-id="element-948">
                <h2 className="text-xl font-semibold mb-3 text-[#2E6BFF]" data-id="element-949">
                  Representative
                </h2>
                <p data-id="element-950">
                  In compliance with Article 27 of the General Data Protection
                  Regulation (GDPR), Pigeon Documents has appointed Prighter as
                  its GDPR representative in the European Union for data
                  protection matters. Prighter gives you an easy way to exercise
                  your privacy-related rights (e.g. requests to access or erase
                  personal data). If you want to contact us via our
                  representative, Prighter or make use of your data subject
                  rights, please visit the following website:{' '}
                  <a href="https://prighter.com/q/18504934450" className="text-[#2E6BFF] hover:underline" data-id="element-951">
                    https://prighter.com/q/18504934450
                  </a>
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </main>
      <Footer data-id="element-952" />
    </div>;
};